import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import PublicRestaurants from './pages/PublicRestaurants';
import MyPoints from './pages/MyPoints';
import SubmitPoints from './pages/SubmitPoints';
import Profile from './pages/Profile';
import Login from './pages/Login';
import Navbar from './components/Navbar';
import authService from './services/authService';
import { User } from './types';
import './App.css';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    // Verificar se há token salvo no localStorage
    const token = authService.getToken();
    const userData = authService.getUser();
    
    if (token && userData) {
      setIsAuthenticated(true);
      setUser({
        username: userData.username || userData.userId,
      });
    }
    setLoading(false);
  }, []);

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        color: 'white',
        fontSize: '18px',
        fontWeight: 600
      }}>
        Carregando...
      </div>
    );
  }

  return (
    <Router>
      <div className="app">
        <Navbar isAuthenticated={isAuthenticated} user={user} setIsAuthenticated={setIsAuthenticated} />
        <div className="app-content">
          <Routes>
            <Route path="/" element={<PublicRestaurants />} />
            <Route path="/login" element={<Login setIsAuthenticated={setIsAuthenticated} setUser={setUser} />} />
            <Route path="/my-points" element={isAuthenticated ? <MyPoints /> : <Navigate to="/login" />} />
            <Route path="/submit-points" element={isAuthenticated ? <SubmitPoints /> : <Navigate to="/login" />} />
            <Route path="/profile" element={isAuthenticated ? <Profile /> : <Navigate to="/login" />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;

